import { AnyObj } from "../monitor/types";

const MAXSUCCESSLISTLENGTH = 60;

const MAXERRORLISTLENGTH = 50;

export function sessionTraceId(data: AnyObj, type: "success" | "error") {
  const { traceId } = data;
  const length = type === "success" ? MAXSUCCESSLISTLENGTH : MAXERRORLISTLENGTH;
  let list = getTraceIdList(type);
  // 重复的traceid不存储
  if (list.findIndex((item: AnyObj) => item.traceId === traceId) === -1) {
    if (list.length === length) {
      list.splice(0, 1);
      list.push(data);
    } else {
      list.push(data);
    }
    setTraceIdList(JSON.stringify(list), type);
  }
}

function getTraceIdList(type: "success" | "error") {
  const list =
    type === "success"
      ? sessionStorage.getItem("monitorTraceIdList")
      : sessionStorage.getItem("monitorTraceIdErrorList");
  let target = []
  try {
    if(list) {
      target = JSON.parse(list)
    }
  } catch(error) {}
  return target
}

function setTraceIdList(target: string, type: "success" | "error") {
  sessionStorage.setItem(
    type === "success" ? "monitorTraceIdList" : "monitorTraceIdErrorList",
    target
  );
}
